import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { adminRouteList, routeList } from "./Config/routeConfig";
import HeaderContent from "./Component/HFSection/HeaderContent";
import { PublicAdminRoute } from "./Config/AdminRoute";
import Login from "./Pages/Admin/Login/Login";
import AdminHeaderContent from "./Component/AdminHFSection/AdminHeaderContent";
import ScrollToTop from "./Component/ScrollToTop";
import PrivateAdminRoute from "./Config/AdminRoute";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <>
      <Toaster position="top-right" />
      <Router>
        <ScrollToTop />
        <Routes>
          {/** Admin Routes */}
          <Route path="/admin" element={null}>
            {/* Protected Admin Routes */}
            <Route element={<PrivateAdminRoute />}>
              <Route element={<AdminHeaderContent />}>
                {adminRouteList.map(({ path, Component, ...rest }) =>
                  <Route key={path} path={path} element={<Component />} {...rest} />
                )}
              </Route>
            </Route>

            {/* Public Admin Routes (Login at /admin) */}
            <Route element={<PublicAdminRoute />}>
              <Route index element={<Login />} />
            </Route>
          </Route>


          {/** Web Routes */}
          <Route element={<HeaderContent />}>
            {routeList.map(({ path, Component, ...rest }) =>
              <Route key={path} path={path} element={<Component />} {...rest} />
            )}
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;